export enum PricingMarginType {
  Currency,
  Percentage
}
